module.exports = __webpack_public_path__ + "static/media/DSCF0010.78b257c6.jpg";